import * as React from 'react';

import classNames from 'classnames';

export const Table = React.forwardRef<
    HTMLTableElement,
    React.HTMLAttributes<HTMLTableElement>
>(({ className, ...props }, ref) => (
    <div className="relative w-full overflow-auto">
        <table
            ref={ref}
            className={classNames(
                'w-full border-spacing-0 overflow-hidden rounded-m border border-solid border-secondary-80 text-s',
                className
            )}
            {...props}
        />
    </div>
));
Table.displayName = 'Table';

export const TableHeader = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <thead
        ref={ref}
        className={classNames(
            'bg-secondary-95 text-s uppercase text-structure-40 [&>tr]:hover:bg-secondary-95',
            className
        )}
        {...props}
    />
));
TableHeader.displayName = 'TableHeader';

export const TableBody = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <tbody
        ref={ref}
        className={classNames(
            'w-full bg-structure-100 [&_tr:last-child_td]:border-b-0',
            className
        )}
        {...props}
    />
));
TableBody.displayName = 'TableBody';

export const TableFooter = React.forwardRef<
    HTMLTableSectionElement,
    React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
    <tfoot
        ref={ref}
        className={classNames(
            'bg-secondary-95 font-med [&>tr]:hover:bg-secondary-95 [&_td]:border-t',
            className
        )}
        {...props}
    />
));
TableFooter.displayName = 'TableFooter';

export const TableRow = React.forwardRef<
    HTMLTableRowElement,
    React.HTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
    <tr
        ref={ref}
        className={classNames(
            'transition-colors hover:bg-structure-80',
            className
        )}
        {...props}
    />
));
TableRow.displayName = 'TableRow';

export const TableHead = React.forwardRef<
    HTMLTableCellElement,
    React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
    <th
        ref={ref}
        className={classNames(
            'border-0 border-b border-solid border-secondary-90 p-l text-left align-middle font-med',
            className
        )}
        {...props}
    />
));
TableHead.displayName = 'TableHead';

export const TableCell = React.forwardRef<
    HTMLTableCellElement,
    React.TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
    <td
        ref={ref}
        className={classNames(
            'border-0 border-b border-solid border-secondary-90 p-l',
            className
        )}
        {...props}
    />
));
TableCell.displayName = 'TableCell';
